import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getAttendeeProfile } from '../lib/api/profiles';
import { featureFlags } from '../lib/featureFlags';

const Header: React.FC = () => {
  const { user, isAdmin, signOut } = useAuth();
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState<string | null>(null);

  useEffect(() => {
    if (!user?.id) {
      setDisplayName(null);
      return;
    }
    let cancelled = false;
    getAttendeeProfile(user.id)
      .then((profile) => {
        if (cancelled) return;
        const first = profile?.first_name?.trim() ?? '';
        const last = profile?.last_name?.trim() ?? '';
        const name = [first, last].join(' ').trim();
        setDisplayName(name || user.email?.split('@')[0] || 'Account');
      })
      .catch(() => {
        if (!cancelled) setDisplayName(user.email?.split('@')[0] || 'Account');
      });
    return () => { cancelled = true; };
  }, [user?.id, user?.email]);

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container">
        <Link className="navbar-brand" to="/">Outreach Bible Project</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/events">Upcoming Events</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/past-events">Past Events</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/gallery">Gallery</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/pin">The Pin</Link>
            </li>
            {/* Temporarily remove the share your faith page */}
            {/* <li className="nav-item">
              <Link className="nav-link" to="/share-your-faith">Share Your Faith</Link>
            </li> */}
            <li className="nav-item">
              <Link className="nav-link" to="/about">About</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/links">Links</Link>
            </li>

            {/* Login link - controlled by feature flag, only shown when not logged in */}
            {featureFlags.showLoginLink && !user && (
              <li className="nav-item">
                <Link className="nav-link" to="/login">
                  <i className="fas fa-sign-in-alt me-1"></i>
                  Login
                </Link>
              </li>
            )}

            {/* User menu - only shown when logged in */}
            {user && (
              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle btn btn-link"
                  type="button"
                  id="userDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fas fa-user-circle me-1"></i>
                  {displayName ?? user.email?.split('@')[0] ?? 'Account'}
                </button>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                  <li>
                    <Link className="dropdown-item" to="/dashboard">
                      <i className="fas fa-tachometer-alt me-2"></i>
                      Dashboard
                    </Link>
                  </li>
                  {isAdmin && (
                    <li>
                      <Link className="dropdown-item" to="/admin">
                        <i className="fas fa-cog me-2"></i>
                        Admin Panel
                      </Link>
                    </li>
                  )}
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <button className="dropdown-item" onClick={handleSignOut}>
                      <i className="fas fa-sign-out-alt me-2"></i>
                      Sign Out
                    </button>
                  </li>
                </ul>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;